/**
 * Shared heading type scale. Every heading on the site is set in Bricolage Grotesque,
 * semibold, sentence case, on the same tight tracking, with one accented word.
 */

/** Standard section heading, used by every numbered section. */
export const sectionHeading =
  "text-[clamp(2.1rem,6.2vw,4.4rem)] font-semibold leading-[0.98] tracking-[-0.055em] text-white";

/** Full-bleed stage heading for the work title and the portfolio page title. */
export const stageHeading =
  "text-[clamp(3.4rem,13vw,9rem)] font-semibold leading-[0.86] tracking-[-0.07em] text-[#f4f6f1]";

/** Card-level heading inside services, work chapters, and viewers. */
export const cardHeading =
  "text-[clamp(1.6rem,3.6vw,2.5rem)] font-semibold leading-[1.04] tracking-[-0.045em] text-white";
